import React, { useState } from 'react';
import './Portfolio.css';

const Portfolio = () => {
  const [activeCategory, setActiveCategory] = useState('All');

  const categories = ['All', 'Web & Enterprise', 'Healthcare', 'E-Commerce & Retail', 'Industrial & B2B'];

  const projects = [
    {
      title: 'MarketIQ Corporate Enterprise',
      category: 'Web & Enterprise',
      impact: 'High-Impact Brand Presence',
      description: 'Comprehensive corporate digital platform built for a premier business consulting firm, featuring interactive service discovery, lead funnels, and enterprise branding.',
      tech: ['React', 'Node.js', 'MongoDB', 'Responsive UI'],
      image: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=1200&q=80',
      url: 'https://marketiqsolutions.in/',
    },
    {
      title: 'Athika Child Care Hospital',
      category: 'Healthcare',
      impact: '24/7 Digital Patient Inquiries',
      description: 'Modern healthcare portal equipped with online doctor appointment booking, seamless WhatsApp API consultations, and emergency patient care guides.',
      tech: ['React', 'Node.js', 'WhatsApp API', 'Cloudflare'],
      image: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&w=1200&q=80',
      url: 'https://athikachildcare.com/',
    },
    {
      title: 'KAG Tiles Premium Showcase',
      category: 'E-Commerce & Retail',
      impact: '+300% Direct Buyer Inquiries',
      description: 'Luxury architectural tiles showcase featuring an interactive high-resolution product catalog, quick WhatsApp quote generation, and visual filter matrix.',
      tech: ['React', 'Node.js', 'WhatsApp API', 'Cloudinary'],
      image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1200&q=80',
      url: 'https://kagtileserode.com',
    },
    {
      title: 'Eagle Star Industrial Enterprises',
      category: 'Industrial & B2B',
      impact: 'Industrial B2B RFP Automation',
      description: 'Industrial pipeline and engineering enterprise website featuring extensive technical product specifications, quotation workflows, and client inquiry pipelines.',
      tech: ['React', 'Node.js', 'WhatsApp API', 'AWS Host'],
      image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=1200&q=80',
      url: 'https://eaglestarenterprises.in',
    },
    {
      title: 'Medixca Pharmacy & Healthcare',
      category: 'Healthcare',
      impact: 'Seamless Medicine Ordering',
      description: 'Digital pharmacy platform with comprehensive OTC & prescription medicine catalog, direct prescription upload, and instant WhatsApp customer support.',
      tech: ['React', 'Node.js', 'WhatsApp API', 'Express'],
      image: 'https://images.unsplash.com/photo-1631549916768-4119b2e5f926?auto=format&fit=crop&w=1200&q=80',
      url: 'https://www.medicxapharmacy.in',
    },
    {
      title: 'NextGen Omnichannel Commerce',
      category: 'E-Commerce & Retail',
      impact: 'Sub-Second Checkout Speeds',
      description: 'High-concurrency e-commerce ecosystem built with microservices, multi-currency support, automated inventory management, and integrated payment gateways.',
      tech: ['React', 'Node.js', 'MongoDB', 'Stripe API'],
      image: 'https://images.unsplash.com/photo-1520607162513-77705c0f0d4a?auto=format&fit=crop&w=1200&q=80',
    },
  ];

  const filteredProjects = activeCategory === 'All'
    ? projects
    : projects.filter(p => p.category === activeCategory);

  return (
    <section id="portfolio" className="portfolio">
      <div className="portfolio-container">
        <div className="section-header">
          <div className="section-badge">
            <span>Featured Work</span>
          </div>
          <h2 className="section-title">Projects We've Built & Scaled</h2>
          <p className="section-subtitle">
            A look at recent web applications, healthcare portals, and digital platforms we've designed and engineered for our clients.
          </p>
        </div>

        {/* Filter Tabs */}
        <div className="portfolio-tabs">
          {categories.map((cat, idx) => (
            <button
              key={idx}
              className={`portfolio-tab-btn ${activeCategory === cat ? 'active' : ''}`}
              onClick={() => setActiveCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Projects Grid */}
        <div className="corporate-portfolio-grid">
          {filteredProjects.map((project, index) => (
            <div key={index} className="corporate-project-card">
              <div className="project-image-wrapper">
                <img
                  src={project.image}
                  alt={`${project.title} preview`}
                  className="project-cover-img"
                  loading="lazy"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = '/logo.png';
                  }}
                />
                <div className="project-image-overlay">
                  {project.url && (
                    <a
                      href={project.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="project-overlay-link"
                      title="Visit Live Website"
                    >
                      <span>Visit Live Website</span>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                        <polyline points="15 3 21 3 21 9"></polyline>
                        <line x1="10" y1="14" x2="21" y2="3"></line>
                      </svg>
                    </a>
                  )}
                </div>
                <div className="project-category-badge">{project.category}</div>
              </div>

              <div className="project-body">
                <div className="project-impact-tag">
                  <span className="impact-dot"></span>
                  <span>{project.impact}</span>
                </div>

                <h3 className="project-title">{project.title}</h3>
                <p className="project-desc">{project.description}</p>

                <div className="project-tech-stack">
                  {project.tech.map((tech, tIdx) => (
                    <span key={tIdx} className="tech-badge">{tech}</span>
                  ))}
                </div>

                {project.url && (
                  <div className="project-card-footer">
                    <a
                      href={project.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="project-live-btn"
                    >
                      <span>Launch Project</span>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="7" y1="17" x2="17" y2="7"></line>
                        <polyline points="7 7 17 7 17 17"></polyline>
                      </svg>
                    </a>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;


